import {Component, OnInit} from '@angular/core';
import {AppService} from '@services/app.service';
import {DateTime} from 'luxon';
import { MatDialog } from '@angular/material/dialog';
import { CambiarContraseniaComponent } from './cambiar-contrasenia/cambiar-contrasenia.component';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
    public user;

    constructor(
        private appService: AppService,
        public dialog: MatDialog
    ) {
        this.user = this.appService.getProfile();
    }

    ngOnInit(): void {

    }

    logout() {
        this.appService.logout();
    }

    formatDate(date) {
        return DateTime.fromISO(date).toFormat('dd LLL yyyy');
    }

    openChangePasswordDialog() {
        const dialogRef = this.dialog.open(CambiarContraseniaComponent, {
            width: '500px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.success) {
                console.log('Contraseña cambiada exitosamente');
            }
        });
    }
}
